import { Box, Flex, Grid, Spinner, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import ActiveUsersChart from '../components/Analytics/ActiveUsersChart'
import AnalyticsLayout from '../components/Analytics/AnalyticsLayout'
import ConversationsChart from '../components/Analytics/ConversationsChart'
import FeedbackDonutChart from '../components/Analytics/FeedbackDonutChart'
import NegativeFeedbackTable from '../components/Analytics/NegativeFeedbackTable'
import { useFeedbackSummary } from '../hooks/analytics/useAnalytics'

const AnalyticsPage: React.FC = () => {
  const feedbackSummary = useFeedbackSummary()

  return (
    <AnalyticsLayout>
      <VStack align='stretch' spacing={6}>
        <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={6}>
          <ChartSlot
            isLoading={feedbackSummary.isLoading}
            isError={feedbackSummary.isError}
          >
            {feedbackSummary.data && <FeedbackDonutChart summary={feedbackSummary.data} />}
          </ChartSlot>
          <ActiveUsersChart />
          <ConversationsChart />
        </Grid>
        <NegativeFeedbackTable />
      </VStack>
    </AnalyticsLayout>
  )
}

const ChartSlot: React.FC<{
  isLoading: boolean
  isError: boolean
  children: React.ReactNode
}> = ({ isLoading, isError, children }) => {
  if (isLoading) {
    return (
      <Flex
        bg='white'
        borderWidth='1px'
        borderColor='gray.200'
        borderRadius='lg'
        height='340px'
        align='center'
        justify='center'
      >
        <Spinner />
      </Flex>
    )
  }
  if (isError) {
    return (
      <Box bg='white' borderWidth='1px' borderColor='gray.200' borderRadius='lg' p={5}>
        <Text color='red.500'>Could not load this widget.</Text>
      </Box>
    )
  }
  return <>{children}</>
}

export default AnalyticsPage
